import isElectron from 'is-electron';

import { setMicPermission } from 'flow/actions/app-actions';
import { setSoftphoneShouldBeRegistered } from 'flow/actions/phone-actions';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { selectTemporaryPasswordState } from 'flow/selectors/app-selectors';
import { selectSoftphoneIsRegistered } from 'flow/selectors/call-selectors';
import {
    addDeviceLogEntry,
    checkBrowserMicrophonePermission,
} from 'flow/utils/browser-utils';
import { checkElectronMicrophonePermission } from 'flow/utils/electron-utils';

const useTempSessionToggle = () => {
    const dispatch = useAppDispatch();
    const loggedInWithTempPass = useAppSelector(selectTemporaryPasswordState);
    const isActuallyRegistered = useAppSelector(selectSoftphoneIsRegistered);
    const tempSessionActive = loggedInWithTempPass && isActuallyRegistered;

    const handleTempSessionToggle = async () => {
        if (!tempSessionActive) {
            const permissionPrompt = isElectron()
                ? await checkElectronMicrophonePermission()
                : await checkBrowserMicrophonePermission();
            if (!permissionPrompt) {
                addDeviceLogEntry('User denied microphone access');
                dispatch(setMicPermission(false));
                return;
            }
            dispatch(setMicPermission(true));
            addDeviceLogEntry('User toggled microphone access on');
        }
        dispatch(setSoftphoneShouldBeRegistered(!tempSessionActive));
    };

    return { tempSessionActive, handleTempSessionToggle };
};

export default useTempSessionToggle;
